import { render, staticRenderFns } from "./MyCoupon.vue?vue&type=template&id=dff558ce&"
import script from "./MyCoupon.vue?vue&type=script&lang=js&"
export * from "./MyCoupon.vue?vue&type=script&lang=js&"
import style0 from "./MyCoupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports